

import React, { useEffect, useState } from "react";
import { FiChevronDown } from "react-icons/fi";

import { getSubjectsByclassId } from "../../lib/ClassApi";
import { getChapterTopic } from "../../lib/LiveclassContent";
import { getMCQReport, getMCQResult } from "../../lib/McqApi";
import ReportDetailsModal from "../../components/common/ReportDetailsModal";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer, } from "recharts";

import { getStudentAttendanceReport } from "../../lib/Attendance";
import { getUserContentUsageReport } from "../../lib/ContentUsesReport";
import { useAuth } from "../../context/AuthProvider";



function Report() {

  // =====================================
  // STATES
  // =====================================

  // const [openModal, setOpenModal] =
  //   useState(false);

  const [selectedReport, setSelectedReport] =
    useState(null);
  const [showDetailsPage, setShowDetailsPage] =
    useState(false);
  //
  const [showTestDetails, setShowTestDetails] =
    useState(false);

  const [showGraph, setShowGraph] =
    useState(false);

  const [selectedTest, setSelectedTest] =
    useState(null);

  const [showReattempts, setShowReattempts] =
    useState(false);

  const [reattemptList, setReattemptList] =
    useState([]);
  //

  const [detailsLoading, setDetailsLoading] =
    useState(false);

  const [student, setStudent] = useState(null);

  const [loading, setLoading] = useState(false);

  const [showReport, setShowReport] = useState(false);

  const [sessions, setSessions] = useState([]);

  const [reportResponse, setReportResponse] =
    useState(null);

  const [classList, setClassList] = useState([]);

  const [subjects, setSubjects] = useState([]);

  const [chapters, setChapters] = useState([]);

  const [students, setStudents] = useState([]);

  const [filters, setFilters] = useState({

    year: new Date()
      .getFullYear()
      .toString(),

    month: String(
      new Date().getMonth() + 1
    ).padStart(2, "0"),

    date: "",

    classId: "",

    subject: "",

    chapter: "",

    topic: "",

    studentId: "" // NEW

  });
  // Teacher Login Report
  const [studentReports, setStudentReports] =
    useState([]);

  const [selectedStudent, setSelectedStudent] =
    useState(null);

  const [teacherView, setTeacherView] =
    useState("list"); // list | details
  //



  const { user } = useAuth();

  const role =
    user?.roleName?.toLowerCase() ||
    user?.role?.toLowerCase();

  const isTeacher = role === "teacher";
  const isStudent = role === "student";
  const isAdmin = role === "admin";


  const [attendance, setAttendance] =
    useState(null);

  const [contentUsage, setContentUsage] = useState(null);


  //const [students, setStudents] = useState([]);

  const currentYear =
    new Date().getFullYear();

  const years = Array.from(
    { length: 15 },
    (_, i) => currentYear - i
  );

  // =====================================
  // MONTHS
  // =====================================

  const months = [

    { label: "Jan", value: "01" },

    { label: "Feb", value: "02" },

    { label: "Mar", value: "03" },

    { label: "Apr", value: "04" },

    { label: "May", value: "05" },

    { label: "Jun", value: "06" },

    { label: "Jul", value: "07" },

    { label: "Aug", value: "08" },

    { label: "Sep", value: "09" },

    { label: "Oct", value: "10" },

    { label: "Nov", value: "11" },

    { label: "Dec", value: "12" },
  ];
  // ======================================
  // VIEW RESULT
  // ======================================



  //===========handle View Report=============
  const handleViewResult = async (item) => {

    try {

      if (!item?.id) {

        alert("Summary Id not found");

        return;

      }

      setDetailsLoading(true);

      setShowDetailsPage(true);

      const res = await getMCQResult(item.id, {
        UserId: Number(student?.uuid ?? student?.UserID ?? student?.userID),
        SchoolId: Number(student?.SchoolId ?? student?.schoolId),
        Role: String(student?.roleName ?? student?.role ?? role),
      });

      setSelectedReport(res);



    } catch (error) {

      console.log(error);

    } finally {

      setDetailsLoading(false);

    }



  };
  //============handle view Details===========//
  const handleViewDetails = (item) => {

    setSelectedTest(item);

    setShowTestDetails(true);

    setShowGraph(false);


  };

  //===========handle Reattampts============
  const handleViewReattempts = (item) => {

    setReattemptList(
      item?.reattemptHistory || []
    );

    setShowReattempts(true);

  };

  // ==================LOGIN USER===================


  useEffect(() => {

    const storedUser =
      localStorage.getItem("user");

    if (storedUser) {

      const userData =
        JSON.parse(storedUser);

      console.log(
        "LOGIN USER:",
        userData
      );

      setStudent(userData);

      // CLASS LIST

      if (userData?.UserClasses) {

        setClassList(
          userData.UserClasses
        );

      }

      // SUBJECT LIST

      if (userData?.UserSubjects) {

        setSubjects(
          userData.UserSubjects
        );

      }

      // AUTO SELECT

      // setFilters((prev) => ({

      //   ...prev,

      //   classId:
      //     userData?.UserClasses?.[0]
      //       ?.ClassId || "",

      //   subject:
      //     userData?.UserSubjects?.[0]
      //       ?.SubjectId || "",
      // }));

      if (isStudent) {
        setFilters((prev) => ({
          ...prev,
          classId:
            userData?.UserClasses?.[0]?.ClassId || "",
          subject:
            userData?.UserSubjects?.[0]?.SubjectId || "",
        }));
      }

    }

  }, []);

  // ============ FETCH SUBJECTS ============


  useEffect(() => {

    if (filters.classId) {

      fetchSubjects(filters.classId);

    }

  }, [filters.classId]);

  const fetchSubjects = async (
    classId
  ) => {

    try {

      const res =
        await getSubjectsByclassId(
          classId
        );

      if (res?.success) {

        setSubjects(res.data || []);

      }

    } catch (error) {

      console.log(error);

    }

  };

  // ============= FETCH CHAPTER ==============

  useEffect(() => {

    if (
      filters.classId &&
      filters.subject
    ) {

      fetchChapterTopic(
        filters.classId,
        filters.subject
      );

    }

  }, [
    filters.classId,
    filters.subject,
  ]);

  const fetchChapterTopic = async (
    classId,
    subjectId
  ) => {

    try {

      const res =
        await getChapterTopic({

          classId,

          subjectId,
        });

      if (res?.success) {

        setChapters(
          res.data || []
        );

      }

    } catch (error) {

      console.log(error);

    }

  };

  // ============ HANDLE FILTER CHANGE===========

  const handleChange = (e) => {

    const { name, value } = e.target;

    setFilters((prev) => ({

      ...prev,

      [name]: value,
    }));

    setShowReport(false);

  };

  // ============== VIEW REPORT ===========

  const handleViewReport =
    async () => {

      try {

        if (
          !filters.classId ||
          !filters.subject
        ) {

          alert(
            "Please select class and subject"
          );

          return;

        }

        setLoading(true);

        // =========================
        // PAYLOAD
        // =========================

        // const payload = {

        //   classId: Number(
        //     filters.classId
        //   ),

        //   //SectionId: 19,

        //   SubjectId: Number(
        //     filters.subject
        //   ),

        //   studentUniqueId: Number(student?.uuid),
        // };

        const identity = {
          UserId: Number(student?.uuid ?? student?.UserID ?? student?.userID),
          SchoolId: Number(student?.SchoolId ?? student?.schoolId),
          Role: String(student?.roleName ?? student?.role ?? role),
        };

        const payload = isTeacher
          ? {
            classId: Number(filters.classId),
            SectionId: null,
            SubjectId: Number(filters.subject),
            ...identity,
          }
          : {
            classId: Number(filters.classId),
            SectionId: null,
            SubjectId: Number(filters.subject),
            studentUniqueId: identity.UserId,
            ...identity,
          };

        console.log(
          "REPORT PAYLOAD:",
          payload
        );

        // =========================
        // API CALL
        // =========================

        // const res =
        //   await getMCQReport(
        //     payload
        //   );

        const res = await getMCQReport(payload);

        setReportResponse(res);

        // if (isTeacher) {

        //   setReportResponse(res);

        //   setStudentReports(
        //     Array.isArray(res?.students)
        //       ? res.students
        //       : []
        //   );

        //   setShowReport(true);

        //   return;
        // }

        if (isTeacher) {

          setStudentReports(
            Array.isArray(res?.students)
              ? res.students
              : []
          );

          const attendanceRes =
            await getStudentAttendanceReport(
              student?.uuid
            );

          console.log(
            "Teacher Attendance",
            attendanceRes
          );

          setAttendance(attendanceRes);

          setShowReport(true);

          return;
        }

        setSessions(
          res?.students?.allLatestTests || []
        );

        setShowReport(true);

        console.log(
          "REPORT RESPONSE:",
          res
        );


        // =========================
        // STORE RESPONSE
        // =========================

        setReportResponse(res);

        // =========================
        // TABLE DATA
        // =========================

        setSessions(
          res?.students
            ?.allLatestTests || []
        );

        // =========================
        // ATTENDANCE API
        // =========================

        const attendanceRes =
          await getStudentAttendanceReport(
            student?.uuid
          );

        console.log(
          "ATTENDANCE RESPONSE:",
          attendanceRes
        );

        setAttendance(attendanceRes);

        // =========================
        // CONTENT USAGE REPORT API
        // =========================

        const usageRes =
          await getUserContentUsageReport(
            student?.uuid
          );

        console.log(
          "CONTENT USAGE RESPONSE:",
          usageRes
        );

        setContentUsage(usageRes);

        setShowReport(true);

      } catch (error) {

        console.log(
          "VIEW REPORT ERROR:",
          error
        );

      } finally {

        setLoading(false);

      }

    };

  //=======================GroupContentUses======================

  const groupedContentUsage =
    Object.values(

      (contentUsage?.data || []).reduce(
        (acc, item) => {

          const type =
            item.resourceType?.toLowerCase();

          if (!acc[type]) {

            acc[type] = {

              resourceType:
                item.resourceType,

              totalUsed: 0,

              totalDuration: 0,

              completed: 0,

              inProgress: 0,
            };

          }

          acc[type].totalUsed += 1;

          acc[type].totalDuration +=
            Number(item.duration || 0);

          if (item.isComplete === 1) {

            acc[type].completed += 1;

          } else {

            acc[type].inProgress += 1;

          }

          return acc;

        },
        {}
      )
    );
  //==================StudentDetails==================
  const handleStudentDetails = async (
    student
  ) => {

    setSelectedStudent(student);

    setSessions(
      student?.allLatestTests || []
    );

    setTeacherView("details");

  };


  //======================
  const totalStudents =
    studentReports?.length || 0;

  const totalTests =
    studentReports.reduce(
      (sum, student) =>
        sum +
        (student?.allLatestTests?.length ||
          0),
      0
    );

  const avgScore =
    totalStudents > 0
      ? (
        studentReports.reduce(
          (sum, student) =>
            sum +
            (student?.lastAttemptTest
              ?.score || 0),
          0
        ) / totalStudents
      ).toFixed(2)
      : 0;


  return (

    <div className="min-h-screen bg-[#F4EFE8] px-4 md:px-8 py-6">

      {/* ===================================== */}
      {/* FILTER SECTION */}
      {/* ===================================== */}

      <div className="mb-10">

        <h2 className="text-[18px] font-semibold mb-5">
          Filter by:
        </h2>

        {isTeacher ? (

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">

            {/* Student */}

            {/* <div>
              <select
                name="studentId"
                value={filters.studentId}
                onChange={handleChange}
                className="w-full bg-white rounded-lg px-5 py-4 border"
              >
                <option value="">
                  Student Name
                </option>

                {students.map((s) => (
                  <option
                    key={s.uuid}
                    value={s.uuid}
                  >
                    {s.firstName} {s.lastName}
                  </option>
                ))}
              </select>
            </div> */}

            {/* Class */}

            <div>
              <select
                name="classId"
                value={filters.classId}
                onChange={handleChange}
                className="w-full bg-white rounded-lg px-5 py-4 border"
              >
                <option value="">
                  Class
                </option>

                {classList.map((item) => (
                  <option
                    key={item.ClassId}
                    value={item.ClassId}
                  >
                    {item.classname}
                  </option>
                ))}
              </select>
            </div>

            {/* Subject */}


            <div>

              <div className="relative">

                <select
                  name="subject"
                  value={filters.subject}
                  onChange={handleChange}
                  className="w-full bg-white rounded-lg px-5 py-4 border appearance-none"
                >

                  <option value="">
                    Select Subject
                  </option>

                  {subjects.map((item) => (

                    <option
                      key={
                        item.SubjectId ||
                        item.subjectId
                      }
                      value={
                        item.SubjectId ||
                        item.subjectId
                      }
                    >

                      {item.SubjectName ||
                        item.subjectName}

                    </option>

                  ))}

                </select>

                <FiChevronDown className="absolute right-4 top-5" />

              </div>

            </div>

            {/* Chapter */}

            {/* <div>
              <select
                name="chapter"
                value={filters.chapter}
                onChange={handleChange}
                className="w-full bg-white rounded-lg px-5 py-4 border"
              >
                <option value="">
                  Chapter
                </option>

                {chapters.map((item) => (
                  <option
                    key={item.chapterId}
                    value={item.chapterId}
                  >
                    {item.chapterName}
                  </option>
                ))}
              </select>
            </div> */}

            {/* Topic */}

            {/* <div>
              <select
                name="topic"
                value={filters.topic}
                onChange={handleChange}
                className="w-full bg-white rounded-lg px-5 py-4 border"
              >
                <option value="">
                  Topic
                </option>
              </select>
            </div> */}

            {/* Button */}

            <div>
              <button
                onClick={handleViewReport}
                className="w-full bg-[#3f35c7] text-white rounded-lg px-5 py-4"
              >
                View Report
              </button>
            </div>

          </div>

        ) : (

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">

            {/* YEAR */}

            <div>

              <div className="relative">

                <select
                  name="year"
                  value={filters.year}
                  onChange={handleChange}
                  className="w-full bg-white rounded-lg px-5 py-4 border appearance-none"
                >

                  <option value="">
                    Select Year
                  </option>

                  {years.map((year) => (

                    <option
                      key={year}
                      value={year}
                    >
                      {year}
                    </option>

                  ))}

                </select>

                <FiChevronDown className="absolute right-4 top-5" />

              </div>

            </div>

            {/* MONTH */}

            <div>

              <div className="relative">

                <select
                  name="month"
                  value={filters.month}
                  onChange={handleChange}
                  className="w-full bg-white rounded-lg px-5 py-4 border appearance-none"
                >

                  <option value="">
                    Select Month
                  </option>

                  {months.map((month) => (

                    <option
                      key={month.value}
                      value={month.value}
                    >
                      {month.label}
                    </option>

                  ))}

                </select>

                <FiChevronDown className="absolute right-4 top-5" />

              </div>

            </div>

            {/* DATE */}

            <div>

              <input
                type="date"
                name="date"
                value={filters.date}
                onChange={handleChange}
                className="w-full bg-white rounded-lg px-5 py-4 border"
              />

            </div>

            {/* CLASS */}
            {/* 
          <div>

            <div className="relative">

              <select
                name="classId"
                value={filters.classId}
                onChange={handleChange}
                className="w-full bg-white rounded-lg px-5 py-4 border appearance-none"
              >

                <option value="">
                  Select Class
                </option>

                {classList.map((item) => (

                  <option
                    key={item.ClassId}
                    value={item.ClassId}
                  >
                    {item.classname}
                  </option>

                ))}

              </select>

              <FiChevronDown className="absolute right-4 top-5" />

            </div>

          </div> */}

            {/* SUBJECT */}

            <div>

              <div className="relative">

                <select
                  name="subject"
                  value={filters.subject}
                  onChange={handleChange}
                  className="w-full bg-white rounded-lg px-5 py-4 border appearance-none"
                >

                  <option value="">
                    Select Subject
                  </option>

                  {subjects.map((item) => (

                    <option
                      key={
                        item.SubjectId ||
                        item.subjectId
                      }
                      value={
                        item.SubjectId ||
                        item.subjectId
                      }
                    >

                      {item.SubjectName ||
                        item.subjectName}

                    </option>

                  ))}

                </select>

                <FiChevronDown className="absolute right-4 top-5" />

              </div>

            </div>

            {/* BUTTON */}

            <div>

              <button
                onClick={
                  handleViewReport
                }
                className="w-full bg-[#3f35c7] text-white rounded-lg px-5 py-4 font-semibold"
              >

                {loading
                  ? "Loading..."
                  : "View Report"}

              </button>

            </div>

          </div>
        )}

      </div>

      {/* =================== REPORT SECTION ================== */}


      {/* ===================================== */}
      {/* REPORT DETAILS MODAL */}
      {/* ===================================== */}

      {showDetailsPage ? (

        <ReportDetailsModal
          reportData={selectedReport}
          loading={detailsLoading}
          onClose={() => {

            setShowDetailsPage(false);

            setSelectedReport(null);

          }}
        />

        //================ Reattampts =====================

      ) : showReattempts ? (

        <>
          {(!isTeacher || teacherView === "details") && (
            <div className="bg-white rounded-2xl shadow-sm overflow-hidden">

              {/* HEADER */}

              <div className="flex items-center justify-between p-6">

                <h2 className="text-[24px] font-bold">

                  Reattempt History

                </h2>

                <button
                  onClick={() => {

                    setShowReattempts(false);

                  }}
                  className="bg-blue-900 text-white px-6 py-3 rounded-lg font-semibold"
                >
                  ← Back
                </button>

              </div>

              {/* TABLE */}

              <div className="overflow-x-auto">

                <table className="w-full">

                  <thead className="bg-gray-100">

                    <tr>

                      <th className="px-6 py-4 text-left">
                        Test ID
                      </th>

                      <th className="px-6 py-4 text-left">
                        Test Name
                      </th>

                      <th className="px-6 py-4 text-left">
                        Start Date
                      </th>

                      <th className="px-6 py-4 text-left">
                        End Date
                      </th>

                      <th className="px-6 py-4 text-left">
                        Score
                      </th>

                      <th className="px-6 py-4 text-left">
                        Result
                      </th>

                      <th className="px-6 py-4 text-left">
                        View Report
                      </th>

                    </tr>

                  </thead>

                  <tbody>

                    {reattemptList?.length > 0 ? (

                      reattemptList.map(
                        (item, index) => (

                          <tr
                            key={index}
                            className="border-b"
                          >

                            <td className="px-6 py-5">
                              {item.testId}
                            </td>

                            <td className="px-6 py-5">
                              {item.testName}
                            </td>

                            <td className="px-6 py-5">
                              {item.startDate}
                            </td>

                            <td className="px-6 py-5">
                              {item.endDate}
                            </td>

                            <td className="px-6 py-5">
                              {item.score}%
                            </td>

                            <td className="px-6 py-5">

                              <span
                                className={`px-3 py-1 rounded-full text-white text-sm
                        ${item.score >= 35
                                    ? "bg-green-600"
                                    : "bg-red-500"
                                  }`}
                              >

                                {item.score >= 35
                                  ? "Pass"
                                  : "Fail"}

                              </span>

                            </td>

                            <td className="px-6 py-5 text-center">

                              <button
                                className="text-blue-600 text-2xl"
                                onClick={() =>
                                  handleViewResult(item)
                                }
                              >
                                👁
                              </button>

                            </td>

                          </tr>

                        )
                      )

                    ) : (

                      <tr>

                        <td
                          colSpan={7}
                          className="text-center py-10"
                        >

                          No Reattempt Found

                        </td>

                      </tr>

                    )}

                  </tbody>

                </table>

              </div>

            </div>
          )}
        </>


      ) : showTestDetails ? (

        <>
          {/* ===================================== */}
          {/* DETAILS PAGE */}
          {/* ===================================== */}

          <div className="bg-white rounded-2xl shadow-sm overflow-hidden mb-6">

            {/* HEADER */}

            <div className="flex items-center justify-between p-6">

              <h2 className="text-[24px] font-bold">

                All Latest Attempted Tests -{" "}
                {reportResponse?.students?.studentFirstName}{" "}
                {reportResponse?.students?.studentLastName}

              </h2>

              <div className="flex gap-4">

                {/* VIEW GRAPH BUTTON */}

                <button
                  onClick={() =>
                    setShowGraph(!showGraph)
                  }
                  className="bg-blue-900 text-white px-6 py-3 rounded-lg font-semibold"
                >
                  📊 View Graph
                </button>

                {/* BACK BUTTON */}

                <button
                  onClick={() => {

                    setShowTestDetails(false);
                    // setShowReport(false);
                    // setShowDetailsPage(false);

                    setShowGraph(false);

                  }}
                  className="bg-blue-900 text-white px-6 py-3 rounded-lg font-semibold"
                >
                  ← Back to Test Results
                </button>

              </div>

            </div>

            {/* ===================================== */}
            {/* GRAPH SECTION */}
            {/* ===================================== */}

            {showGraph ? (

              // <div className="h-[350px] bg-green-500 rounded-xl flex items-center justify-center text-white text-3xl font-bold">

              //   Student  Performance Report

              // </div>
              <div className="w-full h-[400px] p-6">

                {(() => {

                  const total =
                    selectedTest?.totalQuestion || 0;

                  const correct =
                    selectedTest?.correctAnswer || 0;

                  const incorrect =
                    selectedTest?.incorrectAnswers || 0;

                  const attempted =
                    selectedTest?.attemptedQuestion || 0;

                  const unattempted =
                    total - attempted;

                  const data = [
                    {
                      name: "Correct",
                      value: correct,
                    },
                    {
                      name: "Incorrect",
                      value: incorrect,
                    },
                    {
                      name: "Unattempted",
                      value: unattempted,
                    },
                  ];

                  const COLORS = [
                    "#22c55e", // green
                    "#ef4444", // red
                    "#eab308", // yellow
                  ];

                  return (

                    <ResponsiveContainer
                      width="100%"
                      height="100%"
                    >

                      <PieChart>

                        <Pie
                          data={data}
                          cx="50%"
                          cy="50%"
                          labelLine={false}
                          outerRadius={130}
                          dataKey="value"
                          label={({ name, percent }) =>
                            `${name} ${(percent * 100).toFixed(0)}%`
                          }
                        >

                          {data.map((entry, index) => (

                            <Cell
                              key={`cell-${index}`}
                              fill={COLORS[index]}
                            />

                          ))}

                        </Pie>

                        <Tooltip />

                        <Legend />

                      </PieChart>

                    </ResponsiveContainer>

                  );

                })()}

              </div>

            ) : (

              <>

                {/* ================= TABLE SECTION ==================== */}


                <div className="overflow-x-auto">

                  <table className="w-full">

                    <thead className="bg-gray-100">

                      <tr>

                        <th className="px-6 py-4 text-left">
                          Test ID
                        </th>

                        <th className="px-6 py-4 text-left">
                          Test Name
                        </th>

                        <th className="px-6 py-4 text-left">
                          Result
                        </th>

                        <th className="px-6 py-4 text-left">
                          Score
                        </th>

                        <th className="px-6 py-4 text-left">
                          View Report
                        </th>

                        <th className="px-6 py-4 text-left">
                          View Reattampts
                        </th>

                      </tr>

                    </thead>

                    <tbody>

                      <tr className="border-b">

                        <td className="px-6 py-5">
                          {selectedTest?.testId}
                        </td>

                        <td className="px-6 py-5">
                          {selectedTest?.testName}
                        </td>

                        <td className="px-6 py-5">

                          <span
                            className={`px-3 py-1 rounded-full text-white text-sm
                            ${selectedTest?.score >= 35
                                ? "bg-green-600"
                                : "bg-red-500"
                              }`}
                          >

                            {selectedTest?.score >= 35
                              ? "Pass"
                              : "Fail"}

                          </span>

                        </td>

                        <td className="px-6 py-5">
                          {selectedTest?.score}%
                        </td>

                        <td className="px-6 py-5 text-center">

                          <button
                            className="text-blue-600 text-2xl"
                            onClick={() =>
                              handleViewResult(selectedTest)
                            }
                          >
                            👁
                          </button>

                        </td>
                        <td className="px-6 py-5 text-center">

                          <button
                            className="text-blue-600 text-2xl"
                            onClick={() =>
                              handleViewReattempts(selectedTest)
                            }
                          >
                            👁
                          </button>

                        </td>

                      </tr>

                    </tbody>

                  </table>

                </div>

              </>

            )}

          </div>

        </>

      ) : (

        showReport && (
          <>

            {/* ================= STUDENT DETAILS ==================== */}


            {!isTeacher && (
              <div className="bg-white rounded-2xl p-6 shadow-sm mb-8">

                <h2 className="text-[28px] font-bold text-[#3f35c7] mb-6">

                  Student Progress Report

                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

                  <div>

                    <p className="text-gray-500 text-sm">
                      Student Name
                    </p>

                    <h3 className="text-[20px] font-semibold">

                      {
                        reportResponse?.students
                          ?.studentFirstName
                      }{" "}

                      {
                        reportResponse?.students
                          ?.studentLastName
                      }

                    </h3>

                  </div>

                  <div>

                    <p className="text-gray-500 text-sm">
                      Class
                    </p>

                    <h3 className="text-[20px] font-semibold">

                      {
                        reportResponse?.className
                      }

                    </h3>

                  </div>

                  <div>

                    <p className="text-gray-500 text-sm">
                      Subject
                    </p>

                    <h3 className="text-[20px] font-semibold">

                      {
                        reportResponse?.subjectName
                      }

                    </h3>

                  </div>
                  <div>
                    <p className="text-gray-500 text-sm">
                      Report Period
                    </p>

                    <h3 className="text-[20px] font-semibold">
                      {months.find(
                        (m) => m.value === filters.month
                      )?.label}{" "}
                      {filters.year}
                    </h3>
                  </div>

                </div>

              </div>
            )}

            {/* ===================================== */}
            {/* TABLE */}
            {/* ===================================== */}

            {isTeacher && teacherView === "list" && (

              <div className="bg-white rounded-xl shadow-sm overflow-hidden">

                <div className="bg-[#3f35c7] px-6 py-4">
                  <h2 className="text-white text-xl font-bold">
                    Student Reports
                  </h2>
                </div>

                <table className="w-full">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="px-4 py-3">Student</th>
                      <th className="px-4 py-3">Email</th>
                      <th className="px-4 py-3">Score</th>
                      <th className="px-4 py-3">Tests</th>
                      <th className="px-4 py-3">Action</th>
                    </tr>
                  </thead>

                  <tbody>

                    {studentReports.map((student) => (

                      <tr
                        key={student.studentUniqueId}
                        className="border-b"
                      >

                        <td className="px-4 py-3">
                          {student.studentFirstName}
                          {" "}
                          {student.studentLastName}
                        </td>

                        <td className="px-4 py-3">
                          {student.studentEmailId}
                        </td>

                        <td className="px-4 py-3">
                          {student.lastAttemptTest?.score || 0}%
                        </td>

                        <td className="px-4 py-3">
                          {student.allLatestTests?.length || 0}
                        </td>

                        <td className="px-4 py-3">

                          <button
                            onClick={() =>
                              handleStudentDetails(student)
                            }
                            className="bg-[#3f35c7] text-white px-3 py-2 rounded"
                          >
                            View Details
                          </button>

                        </td>

                      </tr>

                    ))}

                  </tbody>
                </table>

              </div>

            )}

            {(!isTeacher || teacherView === "details") && (

              <div className="bg-white rounded-2xl shadow-sm overflow-hidden">

                <div className="bg-[#3f35c7] px-6 py-4">

                  <h2 className="text-white text-[24px] font-bold">

                    All Reports

                  </h2>

                </div>

                <div className="overflow-x-auto">

                  <table className="w-full min-w-[900px]">

                    <thead className="bg-gray-100">

                      <tr>

                        <th className="text-left px-6 py-4">
                          Test Id
                        </th>

                        <th className="text-left px-6 py-4">
                          Test Name
                        </th>

                        <th className="text-left px-6 py-4">
                          Total Question
                        </th>

                        <th className="text-left px-6 py-4">
                          Attempted
                        </th>

                        <th className="text-left px-6 py-4">
                          Correct
                        </th>

                        <th className="text-left px-6 py-4">
                          Incorrect
                        </th>

                        <th className="text-left px-6 py-4">
                          Score
                        </th>

                        <th className="text-left px-6 py-4">
                          Result
                        </th>

                        <th className="text-left px-6 py-4">
                          View Report
                        </th>

                        <th className="text-left px-6 py-4">
                          View Details
                        </th>

                      </tr>

                    </thead>

                    <tbody>

                      {sessions?.length >
                        0 ? (

                        sessions.map(
                          (
                            item,
                            index
                          ) => (

                            <tr
                              key={index}
                              className="border-b"
                            >

                              <td className="px-6 py-5">
                                {
                                  item.testId
                                }
                              </td>

                              <td className="px-6 py-5">
                                {
                                  item.testName
                                }
                              </td>

                              <td className="px-6 py-5">
                                {
                                  item.totalQuestion
                                }
                              </td>

                              <td className="px-6 py-5">
                                {
                                  item.attemptedQuestion
                                }
                              </td>

                              <td className="px-6 py-5">
                                {
                                  item.correctAnswer
                                }
                              </td>

                              <td className="px-6 py-5">
                                {
                                  item.incorrectAnswers
                                }
                              </td>

                              <td className="px-6 py-5 font-semibold">
                                {
                                  item.score
                                }
                                %
                              </td>

                              <td className="px-6 py-5">

                                <span
                                  className={`px-3 py-1 rounded-full text-white text-sm
                              ${item.score >=
                                      35
                                      ? "bg-green-600"
                                      : "bg-red-500"
                                    }`}
                                >

                                  {item.score >=
                                    35
                                    ? "Pass"
                                    : "Fail"}

                                </span>

                              </td>


                              {/* VIEW REPORT */}

                              <td className="px-6 py-5 text-center">

                                <button
                                  className="text-blue-600 text-2xl"
                                  onClick={() =>
                                    handleViewResult(item)
                                  }
                                >
                                  👁
                                </button>

                              </td>

                              {/* VIEW Details */}

                              <td className="px-6 py-5 text-center">

                                <button
                                  className="text-blue-600 text-2xl"
                                  onClick={() =>
                                    handleViewDetails(item)
                                  }
                                >
                                  👁
                                </button>

                                {/* <button
                                className="text-blue-600 text-2xl" onClick={() => {

                                  console.log(
                                    "View Details",
                                    item
                                  );

                                }}
                              >
                                👁
                              </button> */}

                              </td>

                            </tr>

                          )
                        )

                      ) : (

                        <tr>

                          <td
                            colSpan={8}
                            className="text-center py-10"
                          >

                            No Report Found

                          </td>

                        </tr>

                      )}

                    </tbody>

                  </table>

                </div>

              </div>
            )}



            {/* ===================================== */}
            {/* ATTENDANCE REPORT */}
            {/* ===================================== */}


            {/* =================Student Live classAttandance================= */}


            {!isTeacher && (
              <div className="bg-white rounded-2xl p-6 shadow-sm mb-8 mt-10">

                <div className="flex items-center justify-between mb-6">

                  <h2 className="text-[24px] font-bold text-[#3f35c7]">
                    Live Class Attendance Report
                  </h2>

                  <div
                    className={`px-4 py-2 rounded-full text-white font-semibold
              ${attendance?.summary?.percentage >= 75
                        ? "bg-green-600"
                        : attendance?.summary?.percentage >= 50
                          ? "bg-yellow-500"
                          : "bg-red-500"
                      }`}
                  >
                    {attendance?.summary?.percentage}% Attendance
                  </div>

                </div>

                {/* SUMMARY CARDS */}

                <div className="grid grid-cols-1 md:grid-cols-4 gap-5 mb-8">

                  <div className="bg-[#F4EFE8] rounded-xl p-5">
                    <p className="text-gray-500 text-sm">
                      Total Classes
                    </p>
                    <h3 className="text-3xl font-bold">
                      {attendance?.summary?.totalClasses || 0}
                    </h3>
                  </div>

                  <div className="bg-[#F4EFE8] rounded-xl p-5">
                    <p className="text-gray-500 text-sm">
                      Present
                    </p>
                    <h3 className="text-3xl font-bold text-green-600">
                      {attendance?.summary?.presentCount || 0}
                    </h3>
                  </div>

                  <div className="bg-[#F4EFE8] rounded-xl p-5">
                    <p className="text-gray-500 text-sm">
                      Absent
                    </p>
                    <h3 className="text-3xl font-bold text-red-500">
                      {attendance?.summary?.absentCount || 0}
                    </h3>
                  </div>

                  <div className="bg-[#F4EFE8] rounded-xl p-5">
                    <p className="text-gray-500 text-sm">
                      Attendance %
                    </p>
                    <h3 className="text-3xl font-bold text-[#3f35c7]">
                      {attendance?.summary?.percentage || 0}%
                    </h3>
                  </div>

                </div>

                {/*Student attendance HISTORY TABLE */}

                <div className="overflow-x-auto">

                  <table className="w-full">

                    <thead className="bg-gray-100">

                      <tr>

                        <th className="px-6 py-4 text-left">
                          Subject
                        </th>

                        <th className="px-6 py-4 text-left">
                          Start Time
                        </th>

                        <th className="px-6 py-4 text-left">
                          End Time
                        </th>

                        <th className="px-6 py-4 text-left">
                          Join Time
                        </th>

                        <th className="px-6 py-4 text-left">
                          Status
                        </th>

                      </tr>

                    </thead>

                    <tbody>

                      {attendance?.history?.length > 0 ? (

                        attendance.history.map(
                          (item, index) => (

                            <tr
                              key={index}
                              className="border-b"
                            >

                              <td className="px-6 py-5">
                                {item.subjectName}
                              </td>

                              <td className="px-6 py-5">
                                {new Date(
                                  item.startdatetime
                                ).toLocaleString()}
                              </td>

                              <td className="px-6 py-5">
                                {new Date(
                                  item.enddatetime
                                ).toLocaleString()}
                              </td>

                              <td className="px-6 py-5">
                                {item.joinTime
                                  ? new Date(
                                    item.joinTime
                                  ).toLocaleString()
                                  : "-"}
                              </td>

                              <td className="px-6 py-5">

                                <span
                                  className={`px-3 py-1 rounded-full text-white text-sm
                    ${item.attendanceStatus ===
                                      "Present"
                                      ? "bg-green-600"
                                      : "bg-red-500"
                                    }`}
                                >
                                  {item.attendanceStatus}
                                </span>

                              </td>

                            </tr>

                          )
                        )

                      ) : (

                        <tr>

                          <td
                            colSpan={5}
                            className="text-center py-10"
                          >
                            No Attendance History
                          </td>

                        </tr>

                      )}

                    </tbody>

                  </table>

                </div>


              </div>
            )}
            {/* //================Teacher Login============== */}

            {isTeacher && attendance?.students?.length > 0 && (
              <div className="bg-white rounded-2xl p-6 shadow-sm mb-8 mt-10">

                <h2 className="text-[24px] font-bold text-[#3f35c7] mb-5">
                  Student Attendance Report
                </h2>

                <div className="overflow-x-auto">

                  <table className="w-full">

                    <thead className="bg-gray-100">
                      <tr>
                        <th className="px-6 py-4 text-left">
                          Student Name
                        </th>

                        <th className="px-6 py-4 text-left">
                          Total Classes
                        </th>

                        <th className="px-6 py-4 text-left">
                          Present
                        </th>

                        <th className="px-6 py-4 text-left">
                          Absent
                        </th>

                        <th className="px-6 py-4 text-left">
                          Attendance %
                        </th>
                      </tr>
                    </thead>

                    <tbody>

                      {attendance.students.map((item) => (

                        <tr
                          key={item.studentId}
                          className="border-b"
                        >

                          <td className="px-6 py-5">
                            {item.studentName}
                          </td>

                          <td className="px-6 py-5">
                            {item.totalClasses}
                          </td>

                          <td className="px-6 py-5 text-green-600 font-semibold">
                            {item.presentCount}
                          </td>

                          <td className="px-6 py-5 text-red-600 font-semibold">
                            {item.absentCount}
                          </td>

                          <td className="px-6 py-5">

                            <span
                              className={`px-3 py-1 rounded-full text-white
                  ${item.attendancePercentage >= 75
                                  ? "bg-green-600"
                                  : item.attendancePercentage >= 50
                                    ? "bg-yellow-500"
                                    : "bg-red-500"
                                }`}
                            >
                              {item.attendancePercentage}%
                            </span>

                          </td>

                        </tr>

                      ))}

                    </tbody>

                  </table>

                </div>

              </div>
            )}




            {/* ===================================== */}
            {/* USER CONTENT USAGE REPORT */}
            {/* ===================================== */}

            {/* =======================Student login  Content useges Report========== */}

            {!isTeacher && (

              <div className="bg-white rounded-2xl p-6 shadow-sm mb-8 mt-10">

                <div className="flex items-center justify-between mb-6">

                  <h2 className="text-[24px] font-bold text-[#3f35c7]">
                    User Content Usage Report
                  </h2>

                  <div className="bg-blue-600 text-white px-4 py-2 rounded-full font-semibold">
                    Total Usage :
                    {" "}
                    {contentUsage?.summary?.totalUsage || 0}
                  </div>

                </div>

                {/* SUMMARY CARDS */}

                <div className="grid grid-cols-1 md:grid-cols-5 gap-5 mb-8">

                  <div className="bg-[#F4EFE8] rounded-xl p-5">

                    <p className="text-gray-500 text-sm">
                      Total Usage
                    </p>

                    <h3 className="text-3xl font-bold">
                      {contentUsage?.summary?.totalUsage || 0}
                    </h3>

                  </div>

                  <div className="bg-[#F4EFE8] rounded-xl p-5">

                    <p className="text-gray-500 text-sm">
                      Videos
                    </p>

                    <h3 className="text-3xl font-bold text-blue-600">
                      {contentUsage?.summary?.totalVideo || 0}
                    </h3>

                  </div>

                  <div className="bg-[#F4EFE8] rounded-xl p-5">

                    <p className="text-gray-500 text-sm">
                      Images
                    </p>

                    <h3 className="text-3xl font-bold text-green-600">
                      {contentUsage?.summary?.totalImage || 0}
                    </h3>

                  </div>

                  <div className="bg-[#F4EFE8] rounded-xl p-5">

                    <p className="text-gray-500 text-sm">
                      PDFs
                    </p>

                    <h3 className="text-3xl font-bold text-red-500">
                      {contentUsage?.summary?.totalPdf || 0}
                    </h3>

                  </div>

                  <div className="bg-[#F4EFE8] rounded-xl p-5">

                    <p className="text-gray-500 text-sm">
                      Total Duration
                    </p>

                    <h3 className="text-3xl font-bold text-primary">
                      {contentUsage?.summary?.totalDuration || 0}
                      {" "}Min
                    </h3>

                  </div>

                </div>

                {/* TABLE */}

                <div className="overflow-x-auto">

                  <table className="w-full min-w-[1200px]">

                    {/* <thead className="bg-gray-100">

                    <tr>

                      <th className="px-6 py-4 text-left">
                        Resource Type
                      </th>

                      <th className="px-6 py-4 text-left">
                        Subject
                      </th>

                      <th className="px-6 py-4 text-left">
                        Chapter
                      </th>

                      <th className="px-6 py-4 text-left">
                        Topic
                      </th>

                      <th className="px-6 py-4 text-left">
                        View Mode
                      </th>

                      <th className="px-6 py-4 text-left">
                        Duration
                      </th>

                      <th className="px-6 py-4 text-left">
                        Start Time
                      </th>

                      <th className="px-6 py-4 text-left">
                        Status
                      </th>

                    </tr>

                  </thead> */}

                    {/* <tbody>

                    {contentUsage?.data?.length > 0 ? (

                      contentUsage.data.map(
                        (item, index) => (

                          <tr
                            key={index}
                            className="border-b"
                          >

                            <td className="px-6 py-5">

                              <span
                                className={`px-3 py-1 rounded-full text-white text-sm
                    ${item.resourceType === "mp4"
                                    ? "bg-blue-600"
                                    : item.resourceType === "Image"
                                      ? "bg-green-600"
                                      : item.resourceType === "pdf"
                                        ? "bg-red-500"
                                        : "bg-gray-500"
                                  }`}
                              >

                                {item.resourceType}

                              </span>

                            </td>

                            <td className="px-6 py-5">
                              {item.subjectName || "-"}
                            </td>

                            <td className="px-6 py-5">
                              {item.chapterName || "-"}
                            </td>

                            <td className="px-6 py-5">
                              {item.topicName || "-"}
                            </td>

                            <td className="px-6 py-5 capitalize">
                              {item.viewMode}
                            </td>

                            <td className="px-6 py-5">
                              {item.duration || 0} Min
                            </td>

                            <td className="px-6 py-5">

                              {item.startTime
                                ? new Date(
                                  item.startTime
                                ).toLocaleString()
                                : "-"}

                            </td>

                            <td className="px-6 py-5">

                              <span
                                className={`px-3 py-1 rounded-full text-white text-sm
                    ${item.isComplete === 1
                                    ? "bg-green-600"
                                    : "bg-yellow-500"
                                  }`}
                              >

                                {item.isComplete === 1
                                  ? "Completed"
                                  : "In Progress"}

                              </span>

                            </td>

                          </tr>

                        )
                      )

                    ) : (

                      <tr>

                        <td
                          colSpan={8}
                          className="text-center py-10"
                        >

                          No Content Usage Found

                        </td>

                      </tr>

                    )}

                  </tbody> */}

                    <thead className="bg-gray-100">

                      <tr>

                        <th className="px-6 py-4 text-left">
                          Resource Type
                        </th>

                        <th className="px-6 py-4 text-left">
                          Total Used
                        </th>

                        <th className="px-6 py-4 text-left">
                          Total Duration
                        </th>

                        <th className="px-6 py-4 text-left">
                          Completed
                        </th>

                        <th className="px-6 py-4 text-left">
                          In Progress
                        </th>

                      </tr>

                    </thead>

                    <tbody>

                      {groupedContentUsage?.length > 0 ? (

                        groupedContentUsage.map(
                          (item, index) => (

                            <tr
                              key={index}
                              className="border-b"
                            >

                              <td className="px-6 py-5">

                                <span
                                  className={`px-3 py-1 rounded-full text-white text-sm
              ${item.resourceType?.toLowerCase() === "mp4"
                                      ? "bg-blue-600"
                                      : item.resourceType?.toLowerCase() === "image"
                                        ? "bg-green-600"
                                        : item.resourceType?.toLowerCase() === "pdf"
                                          ? "bg-red-500"
                                          : "bg-gray-500"
                                    }`}
                                >

                                  {item.resourceType}

                                </span>

                              </td>

                              <td className="px-6 py-5 font-semibold">
                                {item.totalUsed}
                              </td>

                              <td className="px-6 py-5">
                                {item.totalDuration} Min
                              </td>

                              <td className="px-6 py-5">
                                {item.completed}
                              </td>

                              <td className="px-6 py-5">
                                {item.inProgress}
                              </td>

                            </tr>
                          )
                        )

                      ) : (

                        <tr>

                          <td
                            colSpan={5}
                            className="text-center py-10"
                          >

                            No Content Usage Found

                          </td>

                        </tr>

                      )}

                    </tbody>

                  </table>

                </div>

              </div>
            )}



            {isTeacher && teacherView === "details" && (
              <>
                <div className="bg-white p-6 rounded-xl mb-5">

                  <div className="flex justify-between items-center">

                    <h2 className="text-2xl font-bold">
                      Student Report
                    </h2>

                    <button
                      onClick={() => {
                        setTeacherView("list");
                        setSelectedStudent(null);
                      }}
                      className="bg-[#3f35c7] text-white px-4 py-2 rounded"
                    >
                      Back
                    </button>

                  </div>

                  <div className="grid grid-cols-2 gap-5 mt-5">

                    <div>
                      <p className="text-gray-500">
                        Student Name
                      </p>

                      <h3 className="font-semibold">
                        {selectedStudent?.studentFirstName}
                        {" "}
                        {selectedStudent?.studentLastName}
                      </h3>
                    </div>

                    <div>
                      <p className="text-gray-500">
                        Email
                      </p>

                      <h3 className="font-semibold">
                        {selectedStudent?.studentEmailId}
                      </h3>
                    </div>

                    <div>
                      <p className="text-gray-500">
                        Total Tests
                      </p>

                      <h3 className="font-semibold">
                        {
                          selectedStudent?.allLatestTests?.length
                        }
                      </h3>
                    </div>

                    <div>
                      <p className="text-gray-500">
                        Last Score
                      </p>

                      <h3 className="font-semibold">
                        {
                          selectedStudent?.lastAttemptTest?.score
                        }%
                      </h3>
                    </div>

                  </div>

                </div>
              </>
            )}

          </>



        )
      )
      }





    </div>

  );

}

export default Report;
